const riot = require('riot');
import '../components/stats.tag'
riot.tag2('page-home', '<stats></stats>', '', '', function(opts) {
});

